<div *ngIf="isProd" class="sts-captcha relative" [ngClass]="(passed)?'closed' : ''" [hidden]="passed">
  <div #divCaptcha></div>
  <a href="#" (click)="getAnother()" style="text-decoration:underline" app-sts-cms-txt key="sts-refresh-captcha">Get another?</a>
  <div class="sts-label-row">
    <label app-sts-cms-txt key="sts-enter-captcha" for="captchaInput">Enter text in the field below</label>
  </div>
  <input id="captchaInput"
         autocomplete="off" autocorrect="off" class="sts-textbox" data-val="true"
         [ngClass]="{'has-errors': !passed && submitted && showCaptchaError}"
         data-val-required="Please enter the verification text." type="text"
         [(ngModel)]="captchaText"
         aria-required="true"/>
</div>
